import { Position, PositionResult } from 'vue-router/types/router'
import { Role } from '@/shared/models/role'
import { Route } from '@/shared/interfaces/route'

declare let $: any

export const RouteHelper = {
  meta: {
    auth: {
      admin: {
        auth: {
          roles: [Role.ADMIN],
        },
      },
      premium: {
        auth: {
          roles: [Role.PREMIUM],
        },
      },
      user: {
        auth: {
          roles: [Role.USER],
        },
      },
    },

    noFooter: {
      footer: false,
    },

    noHeader: {
      header: false,
    },

    scrollToTop: {
      scroll: (to: Route, from: Route) => {
        if (!to.query.page && to.name !== from.name) {
          return 0
        } else {
          return false
        }
      },
    },
  },

  scrollBehavior(
    to: Route,
    from: Route,
    savedPosition: Position | void
  ): PositionResult | Promise<PositionResult> {
    return new Promise(resolve => {
      // Let the browser complete the navigation
      setTimeout(() => {
        if (to.meta?.scroll) {
          let newPosition: PositionResult

          if (typeof to.meta.scroll === 'string') {
            const $el = $(to.meta.scroll)

            if ($el.length > 0) {
              const offset = $el.offset()

              if (offset != null) {
                newPosition = {
                  x: 0,
                  y: $el.offset().top,
                }
              }
            }
          } else if (typeof to.meta.scroll === 'number') {
            newPosition = {
              x: 0,
              y: to.meta.scroll,
            }
          } else if (typeof to.meta.scroll === 'function') {
            newPosition = to.meta.scroll(to, from, savedPosition)
          }

          resolve(newPosition)
        } else if (to.hash) {
          resolve({
            selector: to.hash,
          })
        } else if (savedPosition != null) {
          resolve(savedPosition)
        }
      }, 0)
      //
      // if (routesHaveSameParent(from, to) === false && from.name !== to.name) {
      //   setTimeout(() => {
      //     if (to.meta.scroll != null && to.meta.scroll !== false) {
      //       let position: any = 0
      //
      //       if (savedPosition) {
      //         position = savedPosition.y
      //       } else if (typeof to.meta.scroll === 'string') {
      //         const $el = $(to.meta.scroll)
      //
      //         if ($el.length > 0) {
      //           try {
      //             position = $el.offset().top
      //           } catch (e) {
      //             return
      //           }
      //         }
      //       } else if (typeof to.meta.scroll === 'number') {
      //         position = to.meta.scroll
      //       } else if (typeof to.meta.scroll === 'function') {
      //         position = to.meta.scroll(to, from, savedPosition)
      //       }
      //
      //       if (position !== false) {
      //         $('html, body').animate({
      //           scrollTop: position,
      //         })
      //       }
      //     }
      //   }, 10)
    })
  },
}
